/* Premium product-page coordination: variant price, promotion, Wardrobe and sticky purchase. */
(function () {
  'use strict';

  if (window.PrewornProductPageLoaded) return;
  window.PrewornProductPageLoaded = true;

  var OFFER_PATTERN = /buy\s*2|2\s*,?\s*get\s*1|buy.*get.*free/i;

  function parseJson(node, fallback) {
    try { return JSON.parse(node && node.textContent || ''); }
    catch (error) { return fallback; }
  }

  function normalise(value) {
    return String(value || '').replace(/_/g, ' ').replace(/^size\s+/i, '')
      .replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function formatMoney(cents, currency) {
    var amount = Math.max(0, Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currency || 'GBP'
      }).format(amount);
    } catch (error) {
      return '£' + amount.toFixed(2);
    }
  }

  function tierPrice(cents) {
    var original = Math.max(0, Number(cents) || 0);
    var percent = 55;
    var multiplier = .45;

    if (original <= 0) return { original: 0, current: 0, percent: 0 };
    if (original <= 500) {
      percent = 10;
      multiplier = .90;
    } else if (original <= 1000) {
      percent = 20;
      multiplier = .80;
    } else if (original <= 1500) {
      percent = 30;
      multiplier = .70;
    } else if (original <= 2000) {
      percent = 40;
      multiplier = .60;
    } else if (original < 3000) {
      percent = 45;
      multiplier = .55;
    }

    return {
      original: original,
      current: Math.round(original * multiplier),
      percent: percent
    };
  }

  function selectedVariant(section, variants) {
    var input = section.querySelector('form[data-type="add-to-cart-form"] input[name="id"], #Variants-' +
      String(section.getAttribute('data-section') || '') + '');
    var id = input && String(input.value || '');
    for (var index = 0; index < variants.length; index++) {
      if (String(variants[index].id) === id) return variants[index];
    }
    return variants.length ? variants[0] : null;
  }

  function ensurePriceElement(priceRoot, selector, tagName, className) {
    var node = priceRoot.querySelector(selector);
    if (node) return node;
    node = document.createElement(tagName);
    node.className = className;
    if (selector.indexOf('compare') !== -1) node.setAttribute('data-pw-compare-price', '');
    if (selector.indexOf('discount') !== -1) node.setAttribute('data-pw-discount-label', '');
    var offer = priceRoot.querySelector('[data-pw-offer-slot]');
    priceRoot.insertBefore(node, offer || null);
    return node;
  }

  function renderVariant(section, variants) {
    var variant = selectedVariant(section, variants);
    if (!variant) return;
    var currency = (section.querySelector('[data-pw-product-price]') || {})
      .getAttribute ? section.querySelector('[data-pw-product-price]').getAttribute('data-currency-code') : 'GBP';
    var pricing = tierPrice(variant.price);
    var price = pricing.current;
    var compare = pricing.original;
    var priceRoot = section.querySelector('[data-pw-product-price]');
    var current = priceRoot && priceRoot.querySelector('[data-pw-current-price]');
    if (current) current.textContent = formatMoney(price, currency);

    if (priceRoot) {
      var compareNode = priceRoot.querySelector('[data-pw-compare-price]');
      var discountNode = priceRoot.querySelector('[data-pw-discount-label]');
      if (compare > price && compare > 0) {
        compareNode = compareNode || ensurePriceElement(priceRoot, '[data-pw-compare-price]', 's', 'pw-price-compare');
        discountNode = discountNode || ensurePriceElement(priceRoot, '[data-pw-discount-label]', 'span', 'pw-discount-label');
        compareNode.textContent = formatMoney(compare, currency);
        discountNode.textContent = pricing.percent + '% off';
        compareNode.hidden = false;
        discountNode.hidden = false;
      } else {
        if (compareNode) compareNode.hidden = true;
        if (discountNode) discountNode.hidden = true;
      }

      var savingNode = priceRoot.querySelector('[data-pw-price-saving] strong');
      if (savingNode) savingNode.textContent = 'Save ' + formatMoney(compare - price, currency);
    }

    section.querySelectorAll('[data-pw-add-price], [data-pw-sticky-price]').forEach(function (node) {
      node.textContent = formatMoney(price, currency);
    });
    var promotion = section.querySelector('[data-pw-product-promotion]');
    if (promotion) {
      promotion.setAttribute('data-product-price', String(price));
      promotion.setAttribute('data-product-variant-id', String(variant.id || ''));
    }

    var main = section.querySelector('[data-pw-main-purchase]');
    var sticky = section.querySelector('[data-pw-sticky-purchase]');
    if (main && main.name === 'add') main.disabled = variant.available === false;
    if (sticky) {
      sticky.disabled = variant.available === false;
      var label = sticky.querySelector('[data-pw-sticky-label]');
      if (label) label.textContent = variant.available === false ? 'Sold out' : 'Add to Basket';
    }
  }

  function dedupeGallery(section) {
    var gallery = section.querySelector('[data-pw-product-gallery]');
    if (!gallery) return;
    var seen = {};
    var removed = 0;
    gallery.querySelectorAll('.product__media-item').forEach(function (item) {
      var image = item.querySelector('img');
      var source = String(image && (image.currentSrc || image.getAttribute('src')) || '')
        .replace(/^https?:/i, '').split('?')[0].toLowerCase();
      if (!source || !seen[source]) {
        if (source) seen[source] = true;
        return;
      }
      var target = String(item.getAttribute('data-media-id') || '');
      var thumb = target && gallery.querySelector('[data-target="' + target.replace(/"/g, '') + '"]');
      var thumbItem = thumb && thumb.closest ? thumb.closest('.thumbnail-list__item') : null;
      if (thumbItem && thumbItem.parentNode) thumbItem.parentNode.removeChild(thumbItem);
      if (item.parentNode) item.parentNode.removeChild(item);
      removed++;
    });
    if (!removed) return;
    var total = gallery.querySelectorAll('.product__media-item').length;
    gallery.querySelectorAll('.slider-counter--total').forEach(function (node) {
      node.textContent = String(total);
    });
  }

  function offerSaving(cart) {
    var applications = Array.isArray(cart && cart.discount_applications)
      ? cart.discount_applications : [];
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    var saving = 0;

    items.forEach(function (item) {
      var allocations = Array.isArray(item.line_level_discount_allocations)
        ? item.line_level_discount_allocations
        : Array.isArray(item.discount_allocations) ? item.discount_allocations : [];
      allocations.forEach(function (allocation) {
        var application = allocation.discount_application ||
          applications[Number(allocation.discount_application_index)] || {};
        var title = String(application.title || application.description || '');
        if (OFFER_PATTERN.test(title)) saving += Number(allocation.amount) || 0;
      });
    });
    return saving;
  }

  function promotionItemImage(item) {
    var featured = item && item.featured_image;
    if (featured && featured.url) return String(featured.url);
    if (featured && featured.src) return String(featured.src);
    return String(item && item.image || '');
  }

  function promotionAttribute(item, names) {
    if (!item) return '';
    names = names.map(function (name) { return String(name).toLowerCase(); });
    var options = Array.isArray(item.options_with_values) ? item.options_with_values : [];
    for (var optionIndex = 0; optionIndex < options.length; optionIndex++) {
      var optionName = String(options[optionIndex].name || '').toLowerCase();
      if (names.indexOf(optionName) !== -1 && options[optionIndex].value) return String(options[optionIndex].value);
    }
    var properties = item.properties && typeof item.properties === 'object' ? item.properties : {};
    var propertyKeys = Object.keys(properties);
    for (var propertyIndex = 0; propertyIndex < propertyKeys.length; propertyIndex++) {
      var propertyName = String(propertyKeys[propertyIndex]).replace(/^_/, '').toLowerCase();
      if (names.indexOf(propertyName) !== -1 && properties[propertyKeys[propertyIndex]]) {
        return String(properties[propertyKeys[propertyIndex]]);
      }
    }
    return '';
  }

  function inferredPromotionStyle(title, knownValues) {
    var cleaned = String(title || '');
    knownValues.forEach(function (value) {
      value = String(value || '').trim();
      if (!value) return;
      cleaned = cleaned.replace(new RegExp(value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'ig'), ' ');
    });
    cleaned = cleaned
      .replace(/\b(?:men'?s|women'?s|mens|womens|kids?|boys?|girls?)\b/ig, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    if (!cleaned) return '';
    var commonStyles = ['A-Line', 'Wide Leg', 'Straight Leg', 'Bootcut', 'Skinny', 'Slim', 'Bodycon', 'Oversized', 'Relaxed', 'Regular', 'Cropped', 'Maxi', 'Midi', 'Mini', 'Graphic', 'Pleated', 'Wrap'];
    for (var styleIndex = 0; styleIndex < commonStyles.length; styleIndex++) {
      if (cleaned.toLowerCase().indexOf(commonStyles[styleIndex].toLowerCase()) !== -1) return commonStyles[styleIndex];
    }
    return cleaned.split(' ')[0] || '';
  }

  function promotionItemIdentity(item, fallbackTitle) {
    item = item || {};
    var brand = String(item.vendor || promotionAttribute(item, ['brand']) || '');
    var type = String(item.product_type || promotionAttribute(item, ['type', 'product type']) || '');
    var size = promotionAttribute(item, ['size', 'waist size', 'uk size', 'shoe size']);
    var colour = promotionAttribute(item, ['colour', 'color', 'main colour', 'main color']);
    var style = promotionAttribute(item, ['style', 'fit', 'cut']);
    if (!style) style = inferredPromotionStyle(fallbackTitle, [brand, type, size, colour]);

    var values = [brand, type, style, size, colour].filter(function (value, index, all) {
      value = String(value || '').trim();
      if (!value || value.toLowerCase() === 'default title') return false;
      return all.slice(0, index).every(function (earlier) {
        return String(earlier || '').trim().toLowerCase() !== value.toLowerCase();
      });
    }).map(function (value) { return String(value).trim(); });
    return values.length ? values.join(' · ') : String(fallbackTitle || 'One-off piece');
  }

  function projectedFreeItem(cart, root) {
    var count = Math.max(0, Number(cart && cart.item_count) || 0);
    if ((count + 1) % 3 !== 0) return null;

    var units = [];
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    items.forEach(function (item, itemIndex) {
      var quantity = Math.max(1, Number(item.quantity) || 1);
      var originalPrice = Number(item.original_price || item.price || item.final_price || 0);
      var standardPrice = tierPrice(originalPrice).current || Math.max(0, originalPrice);
      var title = String(item.product_title || item.title || 'One-off piece');
      var image = promotionItemImage(item);
      for (var unitIndex = 0; unitIndex < quantity; unitIndex++) {
        units.push({
          key: 'cart:' + itemIndex + ':' + unitIndex,
          title: title,
          compactTitle: promotionItemIdentity(item, title),
          price: standardPrice,
          image: image,
          position: itemIndex + (unitIndex / 100),
          isCurrent: false
        });
      }
    });

    var currentTitle = String(root.getAttribute('data-product-title') || 'this item');
    units.push({
      key: 'current',
      title: currentTitle,
      compactTitle: promotionItemIdentity({
        vendor: root.getAttribute('data-product-brand'),
        product_type: root.getAttribute('data-product-type'),
        properties: {
          Style: root.getAttribute('data-product-style'),
          Size: root.getAttribute('data-product-size'),
          Colour: root.getAttribute('data-product-colour')
        }
      }, currentTitle),
      price: Math.max(0, Number(root.getAttribute('data-product-price')) || 0),
      image: String(root.getAttribute('data-product-image') || ''),
      position: units.length + 1,
      isCurrent: true
    });
    units.sort(function (left, right) {
      return left.price - right.price || left.position - right.position;
    });

    var existingFreeCount = Math.floor(count / 3);
    var projectedFreeCount = Math.floor((count + 1) / 3);
    var existingFree = {};
    units.filter(function (item) { return !item.isCurrent; })
      .sort(function (left, right) { return left.price - right.price || left.position - right.position; })
      .slice(0, existingFreeCount)
      .forEach(function (item) { existingFree[item.key] = true; });

    var projectedFree = units.slice(0, projectedFreeCount);
    for (var freeIndex = 0; freeIndex < projectedFree.length; freeIndex++) {
      if (!existingFree[projectedFree[freeIndex].key]) return projectedFree[freeIndex];
    }
    return null;
  }

  function ensurePromotionReward(root) {
    var reward = root.querySelector('[data-pw-promotion-reward]');
    if (reward) return reward;

    reward = document.createElement('div');
    reward.className = 'pw-product-promotion__reward';
    reward.setAttribute('data-pw-promotion-reward', '');
    reward.hidden = true;

    var image = document.createElement('img');
    image.setAttribute('data-pw-promotion-reward-image', '');
    image.alt = '';
    image.width = 48;
    image.height = 56;
    image.loading = 'lazy';

    var rewardCopy = document.createElement('span');
    rewardCopy.className = 'pw-product-promotion__reward-copy';
    var label = document.createElement('b');
    label.setAttribute('data-pw-promotion-reward-label', '');
    label.textContent = 'Already in your basket';
    var title = document.createElement('span');
    title.setAttribute('data-pw-promotion-reward-title', '');
    var detail = document.createElement('small');
    var badge = document.createElement('em');
    badge.textContent = 'FREE';
    var value = document.createElement('s');
    value.setAttribute('data-pw-promotion-reward-value', '');

    detail.appendChild(value);
    detail.appendChild(badge);
    rewardCopy.appendChild(label);
    rewardCopy.appendChild(title);
    rewardCopy.appendChild(detail);
    reward.appendChild(image);
    reward.appendChild(rewardCopy);
    root.appendChild(reward);
    return reward;
  }

  function renderPromotionReward(root, item, currency) {
    var reward = ensurePromotionReward(root);
    if (!reward) return;
    reward.hidden = !item;
    if (!item) return;

    var image = reward.querySelector('[data-pw-promotion-reward-image]');
    var label = reward.querySelector('[data-pw-promotion-reward-label]');
    var title = reward.querySelector('[data-pw-promotion-reward-title]');
    var value = reward.querySelector('[data-pw-promotion-reward-value]');
    if (label) label.textContent = 'Already in your basket';
    if (title) title.textContent = item.compactTitle || item.title;
    if (value) value.textContent = formatMoney(item.price, currency);
    if (image) {
      image.hidden = !item.image;
      if (item.image) image.src = item.image;
    }
  }

  function cartVariantIsFree(cart, root) {
    var variantId = String(root.getAttribute('data-product-variant-id') || '');
    var count = Math.max(0, Number(cart && cart.item_count) || 0);
    var freeCount = Math.floor(count / 3);
    if (!variantId || freeCount < 1) return false;

    var units = [];
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    items.forEach(function (item, itemIndex) {
      var quantity = Math.max(1, Number(item.quantity) || 1);
      var price = tierPrice(Number(item.original_price || item.price || item.final_price || 0)).current;
      for (var unitIndex = 0; unitIndex < quantity; unitIndex++) {
        units.push({
          variantId: String(item.variant_id || item.id || ''),
          price: price,
          position: itemIndex + (unitIndex / 100)
        });
      }
    });
    units.sort(function (left, right) {
      return left.price - right.price || left.position - right.position;
    });
    return units.slice(0, freeCount).some(function (item) { return item.variantId === variantId; });
  }

  function renderPromotionPrice(section, root, isFree) {
    var currency = String(root.getAttribute('data-currency-code') || 'GBP');
    var price = Math.max(0, Number(root.getAttribute('data-product-price')) || 0);
    var priceRoot = section.querySelector('[data-pw-product-price]');
    var display = isFree ? 'FREE' : formatMoney(price, currency);

    if (priceRoot) {
      if (priceRoot.classList) priceRoot.classList.toggle('is-promotion-free', isFree);
      var current = priceRoot.querySelector('[data-pw-current-price]');
      if (current) current.textContent = display;
      if (isFree) priceRoot.setAttribute('aria-label', 'Free with Buy 2 Get 1 Free');
      else priceRoot.removeAttribute('aria-label');
    }
    if (section.querySelectorAll) {
      section.querySelectorAll('[data-pw-add-price], [data-pw-sticky-price]').forEach(function (node) {
        node.textContent = display;
      });
    }
  }

  function cartContainsVariant(cart, variantId) {
    variantId = String(variantId || '');
    if (!variantId) return false;
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    return items.some(function (item) {
      return String(item.variant_id || item.id || '') === variantId;
    });
  }

  function productIsInCart(cart, root) {
    return cartContainsVariant(cart, root.getAttribute('data-product-variant-id'));
  }

  function updateLiveHeaderCount(count) {
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    var badge = link.querySelector('.pw-header-cart-count');
    if (count > 0 && !badge) {
      badge = document.createElement('span');
      badge.className = 'pw-header-cart-count';
      badge.setAttribute('aria-hidden', 'true');
      link.appendChild(badge);
    }
    if (badge) {
      badge.textContent = count < 100 ? String(count) : '99+';
      badge.hidden = count < 1;
    }
    link.setAttribute('aria-label', 'Bag' + (count ? ', ' + count + (count === 1 ? ' item' : ' items') : ''));
  }

  function dispatchLiveCart(cart) {
    if (typeof window.CustomEvent !== 'function') return;
    window.dispatchEvent(new CustomEvent('preworn:cart-change', { detail: { cart: cart } }));
  }

  function requestLiveCart() {
    if (window.PrewornCart && typeof window.PrewornCart.refresh === 'function') {
      return window.PrewornCart.refresh(false);
    }
    return window.fetch((window.routes && window.routes.cart_url || '/cart') + '.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    });
  }

  function syncCartAfterAdd(section, variantId, attempt, token) {
    var delay = attempt === 0 ? 180 : 220 + (attempt * 80);
    window.setTimeout(function () {
      if (section._pwLiveCartSync !== token) return;
      var managedCart = window.PrewornCart && typeof window.PrewornCart.refresh === 'function';
      requestLiveCart().then(function (cart) {
        if (section._pwLiveCartSync !== token) return;
        renderPromotion(section, cart);
        updateLiveHeaderCount(Math.max(0, Number(cart && cart.item_count) || 0));
        if (!managedCart) dispatchLiveCart(cart);

        if (cartContainsVariant(cart, variantId)) {
          section._pwLiveCartSync = null;
          return;
        }
        if (attempt < 7) syncCartAfterAdd(section, variantId, attempt + 1, token);
      }).catch(function () {
        if (section._pwLiveCartSync === token && attempt < 7) {
          syncCartAfterAdd(section, variantId, attempt + 1, token);
        }
      });
    }, delay);
  }

  function bindLiveCartSync(section) {
    section.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"], form[action*="/cart/add"]')) return;
      var input = form.querySelector('input[name="id"]');
      var promotion = section.querySelector('[data-pw-product-promotion]');
      var variantId = String(input && input.value || promotion && promotion.getAttribute('data-product-variant-id') || '');
      if (!variantId) return;
      section._pwLiveCartSyncCounter = (Number(section._pwLiveCartSyncCounter) || 0) + 1;
      section._pwLiveCartSync = section._pwLiveCartSyncCounter;
      syncCartAfterAdd(section, variantId, 0, section._pwLiveCartSync);
    }, true);
  }

  function renderPromotion(section, cart) {
    var root = section.querySelector('[data-pw-product-promotion]');
    if (!root || root.getAttribute('data-offer-eligible') !== 'true') return;
    var count = Math.max(0, Number(cart && cart.item_count) || 0);
    var confirmedSaving = offerSaving(cart || {});
    var groups = Math.floor(count / 3);
    var remainder = count % 3;
    var status = root.querySelector('[data-pw-promotion-status]');
    var heading = root.querySelector('[data-pw-promotion-heading]');
    var intro = root.querySelector('[data-pw-promotion-intro]');
    var currentFree = root.querySelector('[data-pw-promotion-current-free]');
    var currentFreeValue = currentFree && currentFree.querySelector
      ? currentFree.querySelector('[data-pw-promotion-current-free-value]') : null;
    var basketState = root.querySelector('[data-pw-promotion-basket-state]');
    var freeCount = root.querySelector('[data-pw-promotion-free-count]');
    var freeCountValue = freeCount && freeCount.querySelector
      ? freeCount.querySelector('[data-pw-promotion-free-count-value]') : null;
    var freeCountLabel = freeCount && freeCount.querySelector
      ? freeCount.querySelector('[data-pw-promotion-free-count-label]') : null;
    var inCart = productIsInCart(cart || {}, root);
    var projectedFree = inCart ? null : projectedFreeItem(cart || {}, root);
    var currentProductFree = Boolean(projectedFree && projectedFree.isCurrent) ||
      (inCart && cartVariantIsFree(cart || {}, root));
    var currentWouldBeFree = Boolean(projectedFree && projectedFree.isCurrent);
    var currency = String(root.getAttribute('data-currency-code') || cart && cart.currency || 'GBP');
    var message = 'Buy 2, get your 3rd free.';
    var headline = 'Buy 2, get 1 FREE';
    var introduction = 'Add any 3 items and get the cheapest free.';
    renderPromotionReward(root, null, currency);
    renderPromotionPrice(section, root, currentProductFree);
    if (root.classList) root.classList.toggle('is-in-cart', inCart);
    if (root.classList) root.classList.toggle('is-current-free', currentWouldBeFree);
    if (root.classList) root.classList.toggle('has-reward', Boolean(projectedFree && !projectedFree.isCurrent));
    if (root.classList) root.classList.toggle('has-free-count', groups > 0);
    if (basketState) basketState.hidden = !inCart;
    if (freeCount) {
      freeCount.hidden = groups < 1;
      freeCount.setAttribute('aria-label', groups + ' ' + (groups === 1 ? 'item' : 'items') + ' free');
    }
    if (freeCountValue) freeCountValue.textContent = String(groups);
    if (freeCountLabel) freeCountLabel.textContent = groups === 1 ? 'ITEM' : 'ITEMS';
    if (currentFree) currentFree.hidden = !currentWouldBeFree;
    if (currentFreeValue) {
      currentFreeValue.textContent = formatMoney(
        Math.max(0, Number(root.getAttribute('data-product-price')) || 0),
        currency
      );
    }

    if (inCart && remainder === 0) {
      message = 'Choose 3 more to unlock another.';
    } else if (inCart && remainder === 1) {
      message = groups
        ? groups + ' free ' + (groups === 1 ? 'item' : 'items') + ' confirmed. Choose 2 more eligible items for the next free item.'
        : 'Choose 2 more eligible items to unlock your first free item.';
    } else if (inCart && remainder === 2) {
      message = 'Choose 1 more eligible item to unlock your next free item.';
    } else if (remainder === 2) {
      message = projectedFree
        ? projectedFree.isCurrent
          ? ''
          : 'Add this product to qualify. The lowest-priced item becomes free.'
        : 'Add this to your basket to unlock your next free item.';
      if (projectedFree && projectedFree.isCurrent) {
        headline = 'This item would be FREE!';
        introduction = 'Add it to your basket to unlock your Buy 2 Get 1 Free offer.';
      } else if (projectedFree) {
        headline = 'Add this item. Get one FREE.';
        introduction = 'Your Buy 2 Get 1 Free reward';
        renderPromotionReward(root, projectedFree, currency);
      }
    } else if (remainder === 1) {
      message = 'Add this plus 1 more eligible item to unlock your next free item.';
    } else if (count >= 3 && confirmedSaving > 0) {
      message = groups + ' free ' + (groups === 1 ? 'item' : 'items') + ' confirmed. Add this and 2 more for your next free item.';
    } else if (count >= 3) {
      message = count + ' items in your basket. Add this and 2 more for your next free item.';
    } else if (count === 0) {
      message = 'Add this, then choose 2 more eligible items to get the cheapest free.';
    }
    if (heading) heading.textContent = headline;
    if (intro) intro.textContent = introduction;
    if (status) {
      status.textContent = message;
      status.hidden = currentWouldBeFree;
    }

    var marks = root.querySelectorAll('[data-pw-promotion-progress] i');
    var filled = count >= 3 && remainder === 0 ? 3 : remainder;
    for (var index = 0; index < marks.length; index++) {
      marks[index].classList.toggle('is-filled', index < filled);
      marks[index].classList.toggle('is-free', index === 2 && filled === 3 && confirmedSaving > 0);
    }
  }

  function loadPromotion(section) {
    if (!section.querySelector('[data-pw-product-promotion]')) return;
    var known = window.PrewornCart && typeof window.PrewornCart.getState === 'function'
      ? window.PrewornCart.getState() : null;
    if (known) {
      renderPromotion(section, known);
      return;
    }
    window.fetch((window.routes && window.routes.cart_url || '/cart') + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    }).then(function (cart) {
      renderPromotion(section, cart);
    }).catch(function () {
      /* The offer explanation remains useful if cart status is temporarily unavailable. */
    });
  }

  function wardrobeCategory(options, collections) {
    for (var collectionIndex = 0; collectionIndex < collections.length; collectionIndex++) {
      for (var optionIndex = 0; optionIndex < options.length; optionIndex++) {
        if (String(options[optionIndex].key) === collections[collectionIndex]) return options[optionIndex];
      }
    }
    return null;
  }

  function wardrobeSizes(profile, category) {
    if (!profile || !category) return [];
    var preference = profile.categoryPreferences && profile.categoryPreferences[category.key];
    if (preference && preference.sizeMode === 'all') return [];
    if (preference && preference.sizeMode === 'custom') {
      return Array.isArray(preference.sizes) ? preference.sizes : [];
    }
    return profile.sizes && Array.isArray(profile.sizes[category.sizeType])
      ? profile.sizes[category.sizeType] : [];
  }

  function normaliseSize(value) {
    var key = normalise(value).replace(/^uk\s*/i, '').replace(/^size\s*/i, '').trim();
    var aliases = { small: 's', medium: 'm', large: 'l', 'extra large': 'xl', 'extra small': 'xs' };
    return aliases[key] || key;
  }

  function preferenceMatches(actual, saved, sizeComparison) {
    var actualKey = sizeComparison ? normaliseSize(actual) : normalise(actual);
    if (!actualKey) return false;
    return saved.some(function (value) {
      var savedKey = sizeComparison ? normaliseSize(value) : normalise(value);
      if (!savedKey) return false;
      return actualKey === savedKey || (!sizeComparison && (actualKey.indexOf(savedKey) !== -1 || savedKey.indexOf(actualKey) !== -1));
    });
  }

  function joinLabels(values) {
    if (values.length < 2) return values.join('');
    if (values.length === 2) return values[0] + ' and ' + values[1];
    return values.slice(0, -1).join(', ') + ' and ' + values[values.length - 1];
  }

  function wardrobeMatchResult(root, profile, category, sizes) {
    if (!profile || !category) return null;
    var preference = profile.categoryPreferences && profile.categoryPreferences[category.key] || {};
    var colours = profile.colours && Array.isArray(profile.colours[category.key]) ? profile.colours[category.key] : [];
    var matched = [];
    var differences = [];

    function compare(label, actual, saved, sizeComparison) {
      if (!actual || !Array.isArray(saved) || !saved.length) return;
      if (preferenceMatches(actual, saved, sizeComparison)) {
        matched.push(label === 'size' ? 'size ' + actual : label);
      } else {
        differences.push(label === 'size'
          ? 'size (item ' + actual + '; saved ' + saved.join(', ') + ')'
          : label);
      }
    }

    compare('size', root.getAttribute('data-product-size'), sizes, true);
    compare('colour', root.getAttribute('data-product-colour'), colours, false);
    compare('style', root.getAttribute('data-product-style'), preference.styles || [], false);
    compare('pattern', root.getAttribute('data-product-pattern'), preference.patterns || [], false);
    compare('brand', root.getAttribute('data-product-brand'), preference.brands || [], false);

    var total = matched.length + differences.length;
    if (!total) return null;
    var score = Math.round((matched.length / total) * 100);
    var message = matched.length ? 'Matched: ' + joinLabels(matched) + '.' : '';
    if (differences.length) {
      message += (message ? ' ' : '') + 'Different: ' + joinLabels(differences) + '.';
    } else {
      message += ' All saved specifics align.';
    }
    return {
      score: score,
      state: differences.length ? 'differences' : 'match',
      message: message
    };
  }

  function setWardrobeMessage(root, title, message, state, score) {
    var titleNode = root.querySelector('[data-pw-wardrobe-match-title]');
    var messageNode = root.querySelector('[data-pw-wardrobe-match-status]');
    var scoreNode = root.querySelector('[data-pw-wardrobe-match-score]');
    var iconNode = root.querySelector('.pw-wardrobe-match__icon');
    if (titleNode) titleNode.textContent = title;
    if (messageNode) messageNode.textContent = message;
    if (scoreNode) {
      scoreNode.hidden = typeof score !== 'number';
      if (typeof score === 'number') scoreNode.textContent = score + '% match';
    }
    root.classList.toggle('is-neutral', state === 'neutral');
    root.classList.toggle('is-match', state === 'match');
    root.classList.toggle('has-differences', state === 'differences');
    if (iconNode) iconNode.textContent = state === 'match' ? '✓' : state === 'differences' ? '!' : '?';
  }

  function populateSizePicker(root, api, category, audience, productSize) {
    var saveArea = root.querySelector('[data-pw-wardrobe-save]');
    var select = root.querySelector('[data-pw-wardrobe-size-select]');
    var button = root.querySelector('[data-pw-wardrobe-size-save]');
    if (!saveArea || !select || !button || !category || !category.sizeType) return;

    api.getCategorySizeOptions(category.key, audience).then(function (sizes) {
      if (!Array.isArray(sizes) || !sizes.length) return;
      select.innerHTML = '<option value="">Choose size</option>' + sizes.map(function (size) {
        var selected = normalise(size) === normalise(productSize) ? ' selected' : '';
        return '<option value="' + String(size).replace(/&/g, '&amp;').replace(/"/g, '&quot;') + '"' + selected + '>' +
          String(size).replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</option>';
      }).join('');
      saveArea.hidden = false;
      if (button.getAttribute('data-pw-bound') === 'true') return;
      button.setAttribute('data-pw-bound', 'true');
      button.addEventListener('click', function () {
        var value = String(select.value || '');
        if (!value) {
          setWardrobeMessage(root, 'Choose a size', 'Select the size you would like My Wardrobe to remember.', 'neutral');
          return;
        }
        button.disabled = true;
        button.textContent = 'Saving…';
        api.setCategorySize(category.key, value, category.sizeType, audience, {
          activate: false,
          source: 'product_page'
        }).then(function () {
          saveArea.hidden = true;
          setWardrobeMessage(root, 'Size saved', 'My Wardrobe will use this size for future recommendations.', 'match', 100);
        }).catch(function () {
          setWardrobeMessage(root, 'Could not save size', 'Please open My Wardrobe and try again.', 'neutral');
        }).then(function () {
          button.disabled = false;
          button.textContent = 'Save size';
        });
      });
    }).catch(function () {
      /* The full Wardrobe editor remains available through the Edit action. */
    });
  }

  function renderWardrobe(section) {
    var root = section.querySelector('[data-pw-wardrobe-match]');
    var api = window.PrewornWardrobe;
    if (!root || !api || typeof api.ready !== 'function') return;
    var audience = String(root.getAttribute('data-product-audience') || '');
    var productSize = String(root.getAttribute('data-product-size') || '');
    var collections = String(root.getAttribute('data-product-collections') || '').split(',')
      .map(function (value) { return value.trim(); }).filter(Boolean);

    if (!audience || !productSize || !collections.length) {
      setWardrobeMessage(root, 'Wardrobe compatibility', 'Open My Wardrobe to save the sizes and specifics you shop for.', 'neutral');
      return;
    }

    Promise.resolve(api.ready()).then(function () {
      return Promise.resolve(api.getCategoryOptions(audience)).then(function (options) {
        var category = wardrobeCategory(Array.isArray(options) ? options : [], collections);
        var profile = typeof api.getWardrobeForAudience === 'function'
          ? api.getWardrobeForAudience(audience) : api.getWardrobe();
        var hasCategory = category && profile && Array.isArray(profile.categories) &&
          profile.categories.indexOf(category.key) !== -1;
        var sizes = hasCategory ? wardrobeSizes(profile, category) : [];
        var categoryLabel = category && category.label ? category.label : 'this category';
        var result = hasCategory ? wardrobeMatchResult(root, profile, category, sizes) : null;

        if (result) {
          setWardrobeMessage(root, 'Wardrobe compatibility', result.message, result.state, result.score);
        } else {
          setWardrobeMessage(root, 'Wardrobe compatibility', 'Add preferences for ' + categoryLabel + ' to see a match score.', 'neutral');
          populateSizePicker(root, api, category, audience, productSize);
        }
      });
    }).catch(function () {
      setWardrobeMessage(root, 'Wardrobe compatibility', 'My Wardrobe is temporarily unavailable. You can still add this item to your bag.', 'neutral');
    });
  }

  function bindSticky(section) {
    var bar = section.querySelector('[data-pw-sticky-purchase-bar]');
    var anchor = section.querySelector('.pw-buy-block');
    if (!bar || !anchor || typeof window.IntersectionObserver !== 'function') return;
    bar.hidden = false;
    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      bar.classList.toggle('is-visible', passed);
      bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
    }, { threshold: 0 });
    observer.observe(anchor);

    var button = bar.querySelector('[data-pw-sticky-purchase]');
    if (button) button.addEventListener('click', function () {
      var main = section.querySelector('[data-pw-main-purchase]');
      if (!main || main.disabled) return;
      main.click();
    });
  }

  function initSection(section) {
    if (!section || section.getAttribute('data-pw-product-page-bound') === 'true') return;
    section.setAttribute('data-pw-product-page-bound', 'true');
    var variants = parseJson(section.querySelector('[data-pw-product-variants]'), []);
    dedupeGallery(section);
    renderVariant(section, variants);
    renderWardrobe(section);
    bindSticky(section);
    bindLiveCartSync(section);
    loadPromotion(section);

    section.addEventListener('change', function (event) {
      if (!event.target.closest('variant-selects, variant-radios, [name="id"], .product-form__input')) return;
      window.setTimeout(function () { renderVariant(section, variants); }, 0);
    });

    window.addEventListener('preworn:cart-change', function (event) {
      if (event.detail && event.detail.cart) {
        renderPromotion(section, event.detail.cart);
        var promotion = section.querySelector('[data-pw-product-promotion]');
        var variantId = promotion && promotion.getAttribute('data-product-variant-id');
        if (cartContainsVariant(event.detail.cart, variantId)) section._pwLiveCartSync = null;
      }
    });
    window.addEventListener('preworn:wardrobe-change', function () {
      renderWardrobe(section);
    });
  }

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var sections = context.querySelectorAll('section[id^="MainProduct-"]');
    for (var index = 0; index < sections.length; index++) initSection(sections[index]);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
